import { formatMs } from '@/app/pages/Diagnostics/diagnosticsUtils'
import { NetworkSpeedPopover } from '@/components/network-status/NetworkSpeedPopover'
import { StatusIcon } from '@/components/network-status/SignalBars'
import { STATUS_LABEL, STATUS_TONE, connectionStatus, isTier } from '@/components/network-status/networkTier'
import { useNetworkPing } from '@/components/network-status/useNetworkPing'
import { hasRecentResult, useSpeedTest } from '@/components/network-status/useSpeedTest'
import { FOOTER_SQUARE_CLASS } from '@/components/sidebar-footer/footerSquare'
import { Popover, PopoverTrigger } from '@/components/ui/popover'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { useOnlineStatus } from '@/hooks/useOnlineStatus'
import { cn } from '@/lib/utils'
import { useState } from 'react'

/** Footer square showing the connection as signal bars; opens the speed popover. */
export function NetworkStatusButton() {
	const online = useOnlineStatus()
	const [open, setOpen] = useState(false)
	const test = useSpeedTest()
	const ping = useNetworkPing({ live: open, enabled: online && test.phase !== 'running' })
	const status = connectionStatus(online, ping.data)
	const internetMs = ping.data?.internetMs
	const label =
		isTier(status) && internetMs !== undefined
			? `${STATUS_LABEL[status]} connection, ping ${formatMs(internetMs)}`
			: STATUS_LABEL[status]

	const handleOpenChange = (next: boolean) => {
		setOpen(next)
		if (next && online && test.phase !== 'running' && !hasRecentResult(test, Date.now())) {
			test.start()
		} else if (!next && test.phase === 'running') {
			test.stop()
		}
	}

	return (
		<Popover open={open} onOpenChange={handleOpenChange}>
			<Tooltip>
				<TooltipTrigger asChild>
					<PopoverTrigger asChild>
						<button
							type='button'
							aria-label={label}
							data-testid='network-status-trigger'
							data-tier={status}
							className={cn(FOOTER_SQUARE_CLASS, 'hover:bg-sidebar-accent')}>
							<StatusIcon status={status} className={STATUS_TONE[status].text} />
						</button>
					</PopoverTrigger>
				</TooltipTrigger>
				<TooltipContent side='top'>{label}</TooltipContent>
			</Tooltip>
			<NetworkSpeedPopover online={online} ping={ping.data} test={test} />
		</Popover>
	)
}
